/* eslint-disable class-methods-use-this */
const onload = 'YandexMapsApiOnload';
const onerror = 'YandexMapsApiOnerror';

const callbacks = { onload, onerror };

const mode = process.env.NODE_ENV === 'development' ? 'debug' : 'release';
const ns = 'YandexMapsApi';
const lang = 'ru_RU';

class YandexMapsApi {
  constructor() {
    this.api = typeof window !== 'undefined' ? window[ns] || null : null;
    this.promise = null;
  }

  fetchScript(url) {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');

      script.type = 'text/javascript';
      script.onload = resolve;
      script.onerror = reject;
      script.src = url;
      script.async = 'async';

      document.head.appendChild(script);
    });
  }

  getBaseUrl(version = '2.1', enterprise = false) {
    const protocol = 'https:';
    const host = enterprise
      ? 'enterprise.api-maps.yandex.ru'
      : 'api-maps.yandex.ru';

    return `${protocol}//${host}/${version}/`;
  }

  getQuery(query) {
    const options = {
 ns, lang, mode, ...query, ...callbacks,
};

    return Object.keys(options)
      .reduce(
        (prev, key) => {
          if (typeof options[key] === 'undefined') return prev;
          return prev.concat(`${key}=${options[key]}`);
        },
        [],
      )
      .join('&');
  }

  load(query, version, enterprise) {
    if (this.promise) return this.promise;

    this.promise = new Promise((resolve, reject) => {
      const baseUrl = this.getBaseUrl(version, enterprise);
      const urlQuery = this.getQuery(query);

      window[onload] = (api) => {
        resolve(api);
        this.api = api;
        window[onload] = null;
      };

      window[onerror] = (error) => {
        reject(error);
        window[onerror] = null;
      };

      this.fetchScript(`${baseUrl}?${urlQuery}`).catch(reject);
    });

    return this.promise;
  }

  get(query, version, enterprise) {
    return new Promise((resolve, reject) => {
      if (this.api) {
        return resolve(this.api);
      }

      return this.load(query, version, enterprise).then(
        (api) => {
          resolve(api);
        },
        () => {
          reject();
        },
      );
    });
  }

  fixScroll(map, delay) {
    if (!map) return;

    let hoverTimer;

    function disableZoom(map) {
      map.behaviors.disable(['scrollZoom', 'multiTouch', 'drag']);
    }

    function enableZoom(map) {
      map.behaviors.enable(['scrollZoom', 'multiTouch', 'drag']);
    }

    map.events.add('click', () => {
      enableZoom(map);
    });

    map.events.add('multitouchstart', () => {
      enableZoom(map);
    });

    map.events.add('mouseenter', () => {
      hoverTimer = setTimeout(() => {
        enableZoom(map);
      }, delay || 1000);
    });

    map.events.add('mouseleave', () => {
      clearTimeout(hoverTimer);
      disableZoom(map);
    });

    disableZoom(map);
  }
}

export default new YandexMapsApi();
